module.exports = __webpack_public_path__ + "static/chain_devil-322d483736b4b61b3a4c81b38a0e59f0.jpg";